var EHDI = EHDI || Object.create(null);

EHDI.utils = EHDI.utils || Object.create(null);

EHDI.utils.CropUtils = Object.create(null);

EHDI.utils.CropUtils.combineCrops = function(crops){
    if(crops == null) return;
    var copied = [];
    for(var y = 0, l = crops.length; y < l; y++){
        for(var x = 0, xl = crops[y].length; x < xl; x++)
            copied.push(crops[y][x]);
    }
    return copied;
};

/*
EHDI.utils.CropUtils.copyCrops = function(crops){
    var copied = [];
    for(var y = 0, l = crops.length; y < l; y++)
        copied.push(crops[y].slice());
    return copied;
};
*/

EHDI.utils.CropUtils.getCropsWithMatches = function(crops){
    var matches = [];
    var copied = EHDI.utils.CropUtils.combineCrops(crops);
    while(copied.length > 0){
        if(copied[0].cropState == EHDI.components.CropState.GROWN){
            var connected = EHDI.utils.CropUtils.getConnectedCrops(crops, [copied[0]], 0);
            var matchFound = false;
            if(connected.length >= 3) 
                {
                    copied[0].glowOn();
                    matches.push(connected);
                    matchFound = true;
                }


            var index = 0;
            for(var i = 0, l = connected.length; i < l; i++){
                if(matchFound)
                    connected[i].glowOn();

                index = copied.indexOf(connected[i]);
                if(index != -1) copied.splice(index,1);
            }
        }
        else copied.splice(0,1);
    }
    return matches;
};
/*
EHDI.utils.CropUtils.getCropsWithNoMatches = function(crops){
    var copied = EHDI.utils.CropUtils.combineCrops(crops);
    var curIndex = 0;
    while(curIndex < copied.length){
        var connected = EHDI.utils.CropUtils.getConnectedCrops(crops, [copied[curIndex]], 0);
        if(connected.length >= 3) {
            console.log("REMOVE");
            var index = 0;
            for(var i = 0, l = connected.length; i < l; i++){
                index = copied.indexOf(connected[i]);
                if(index != -1) copied.splice(index,1);
            }
            continue;
        }
        curIndex++;
    }
    return copied;
};
*/

EHDI.utils.CropUtils.getConnectedCrops = function(crops, group, index){
    var type = group[index].cropState;
    var neighbors = EHDI.utils.CropUtils.getNeighborCrops(crops, group[index], type);
    for(var i = 0, l = neighbors.length; i < l; i++){
        if(group.indexOf(neighbors[i]) == -1) group.push(neighbors[i]);
    }
    index++;
    if(index < group.length) return EHDI.utils.CropUtils.getConnectedCrops(crops, group, index);
    else return group;

};

EHDI.utils.CropUtils.getNeighborCrops = function(crops, crop, type){
    var cIndex = EHDI.utils.CropUtils.getCropIndex(crops, crop);
    var neighbors = [];
    if(cIndex.x + 1 < crops[cIndex.y].length) neighbors.push(crops[cIndex.y][cIndex.x +1]);
    if(cIndex.x - 1 > 0) neighbors.push(crops[cIndex.y][cIndex.x - 1]);
    if(cIndex.y + 1 < crops.length) neighbors.push(crops[cIndex.y + 1][cIndex.x]);
    if(cIndex.y - 1 > 0) neighbors.push(crops[cIndex.y - 1][cIndex.x]);
    for(var i = 0; i < neighbors.length; i++){
        if((neighbors[i].cropState != type && type != null) || neighbors[i] == null){
            neighbors.splice(i,1);
            i--;
        }
    }    
    return neighbors;
};

EHDI.utils.CropUtils.isNeighbors = function(crops, cropA, cropB){
    var cIndex = EHDI.utils.CropUtils.getCropIndex(crops, cropA);
    var nIndex = EHDI.utils.CropUtils.getCropIndex(crops, cropB);
    if(cIndex == null || nIndex == null) return false;
    var dx = Math.abs(cIndex.x - nIndex.x);
    var dy = Math.abs(cIndex.y - nIndex.y);
    if((dx == 1 && dy == 0)||(dx == 0 && dy == 1)) return true;
    return false;
};

EHDI.utils.CropUtils.getCropInLoc = function(crops, loc){
    for(var y = 0, l = crops.length; y < l; y++){
        for( var x = 0, xl = crops[y].length; x < xl; x++){
            if(crops[y][x].getBounds(false).contains(loc.x, loc.y)) return crops[y][x];
        }
    }
    return null;
};

EHDI.utils.CropUtils.getCropIndex = function(crops, crop){
    for(var y = 0, l = crops.length; y < l; y++){
        for( var x = 0, xl = crops[y].length; x < xl; x++){
            if(crops[y][x] == crop) return new PIXI.Point(x,y);
        }
    }
    return null;
};